import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-job-project-widget',
  templateUrl: './create-job-project-widget.component.html',
  styleUrls: ['./create-job-project-widget.component.scss']
})
export class CreateJobProjectWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
